module.exports = __webpack_public_path__ + "img/dots_rbb5.0aa8ee3f.png";